<template>
	<div class="social-container" :style="style" :class="['el-'+details.id]">
		<v-style>
			{{css}}
			{{ hoverStyle }}
		</v-style>
	<ul class="social" v-if="basic.items"  :id="advanced.cssId"
	    :class="['el-id-'+details.id, advanced.cssClasses, responsiveClasses]">
		<li v-for="(item, index) in basic.items" :key="index" v-if="item.status">
			<a :href="item.url||'#'" target="_blank" :class="item.title" :style="{color: basic.color?basic.color:null}">
        <span :class="item.title" :data-icon="item.icon">
            <inline-svg :src="'/img/'+item.icon"/>
        </span>
			</a>
		</li>
	</ul>

	<!-- заглушка -->
	<ul class="social" v-else :style="style" :id="advanced.cssId" :class="[advanced.cssClasses, responsiveClasses]">
		<li>
			<a>
				<img :src="require('@/assets/page/img/tw_icon.svg')"/>
			</a>
		</li>
		<li>
			<a>
				<img :src="require('@/assets/page/img/in_icon.svg')"/>
			</a>
		</li>
		<li>
			<a>
				<img :src="require('@/assets/page/img/face_b_icon.svg')"/>
			</a>
		</li>
		<li>
			<a>
				<img :src="require('@/assets/page/img/youtube_icon.svg')"/>
			</a>
		</li>
		<li>
			<a>
				<img :src="require('@/assets/page/img/instagram_icon.svg')"/>
			</a>
		</li>
	</ul>
	</div>
</template>

<script>
import {borderProps, getPadding, responsiveAlignStyles} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'EmailSocial',
	props: ['details'],
	computed: {
		basic() {
			return this.details.attributes.basic
		},
		advanced() {
			return this.details.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		css() {
			return responsiveAlignStyles(this.basic.align, this.details.id);
		},
		hoverStyle() {
			let color = this.basic.hoverColor ? this.basic.hoverColor + ' !important' : 'initial';

			return ('.el-' + this.details.id + ' a:hover { color: ' + color + ';}');
		},
		style() {
			return {
				...borderProps(this.advanced.border),
				margin: getPadding(this.basic.margin),
				padding: getPadding(this.advanced.padding),
				backgroundColor: this.advanced.backgroundColor || null,
			}
		}
	}
}
</script>
